export class Handler {
    constructor({ name, build, detect, helper, parse }) {
        this.name = name;
        this.helper = helper;
        this.build = build;
        this.detect = (content) => {
            if (typeof content !== "string") {
                throw new Error("Expected string content!");
            }
            return detect(content);
        };
        this.parse = (content, _options) => {
            if (typeof content !== "string") {
                throw new Error("Expected string content!");
            }
            return parse(content, _options);
        };
    }
}
export const buildHandler = (args) => {
    return new Handler(args);
};
